import { getRules } from 'utils/util'

// ------------------基本信息------------------
export const BASE_INFO_SCHEMA = {
  code: {
    label: '企业ID',
  },
  name: {
    label: '企业名称',
  },
  companyType: {
    label: '公司类型',
    slotName: 'company-type',
  },
  exposure: {
    label: '信用限额敞口(元)',
    showTooltip: true,
    tooltip: '信用限额敞口 = 有效期内的限额 - 当前有效额度',
    tooltipIcon: 'question-circle',
    filter: 'formatAmount',
  },
  groupExposure: {
    label: '集团限额敞口(元)',
    showTooltip: true,
    tooltip: '集团限额敞口 = 已生效限额 - 集团总额度',
    tooltipIcon: 'question-circle',
    filter: 'formatAmount',
  },
  totalCreditLimit: {
    label: '当前有效信用限额(元)',
    filter: 'formatAmount',
  },
  limitControlAmount: {
    label: '限额条件',
    slotName: 'limit-control-amount',
  },
  riskWarning: {
    label: '风险标签',
    slotName: 'riskWarning',
  },
  effectiveAmount: {
    label: '当前有效额度(元)',
    showTooltip: true,
    tooltip: '当前有效额度 = 有效期内的临时额度 + 正常额度 + 专项额度',
    tooltipIcon: 'question-circle',
    filter: 'formatAmount',
  },
  groupTotalAmount: {
    label: '集团总额度(元)',
    filter: 'formatAmount',
  },
  netAr: {
    label: '企业Net AR',
    filter: 'formatAmount',
  },
}

export const BASE_INFO_EXTRA_SCHEMA = {
  totalCreditLimit: {
    label: '当前有效信用限额(元)',
    slotName: 'link',
    jumpUrl: '/client/client-center/detail/credits',
    filter: 'formatAmount',
  },
  netAr: {
    label: '企业Net AR',
    slotName: 'link',
    jumpUrl: '/client/client-center/detail/application-data',
    filter: 'formatAmount',
  },
  groupNetAr: {
    label: '集团Net AR',
    filter: 'formatAmount',
  },
  financeTarget: {
    label: '详细财务指标',
    slotName: 'link',
    jumpUrl: '/client/client-center/detail/financial-analysis',
  },
  kpiTarget: {
    label: '详细KPI指标',
    slotName: 'link',
    jumpUrl: '/client/client-center/detail/kpi-data',
  },
  creditLevel: {
    label: '信用评级',
    defaultValue: '无',
  },
  assurance: {
    label: '担保额度(元)',
    slotName: 'link',
    jumpUrl: '/client/client-center/detail/guarantee',
    filter: 'formatAmount',
  },
  insurance: {
    label: '保险额度(元)',
    slotName: 'link',
    jumpUrl: '/client/client-center/detail/Insurance',
    filter: 'formatAmount',
  },
  fscore: {
    label: 'F-SCORE',
    defaultValue: '无',
  },
  zscore: {
    label: 'Z-SCORE',
    defaultValue: '无',
  },
  loanExposure: {
    label: '融资金额(元)',
    slotName: 'link',
    jumpUrl: '/client/client-center/center/financing-data',
    filter: 'formatAmount',
  },
  overdue: {
    label: '逾期金额(元)',
    slotName: 'link',
    jumpUrl: '/client/client-center/detail/application-data',
    filter: 'formatAmount',
  },
  insCoverRate: {
    label: '保险覆盖率',
    slotName: 'insurance-coverage',
  },
}

// ------------------申请明细Edit信息------------------
export const APPLY_EDIT_SCHEMA = {
  // business: {
  //   label: '业务类型',
  //   type: 'select',
  //   optionList: [],
  //   fieldNames: { label: 'name', value: 'id' },
  //   rules: getRules('请选择业务类型'),
  //   emit: 'handleBusinessChange', // 监听
  // },
  business: {
    label: '业务类型',
    slotName: 'business',
  },
  region: {
    label: '大区',
    slotName: 'region',
  },
  model: {
    label: '业务模式',
    slotName: 'model',
  },
  creditArea: {
    label: '信控区',
    slotName: 'credit-area',
  },
  legalEntity: {
    label: '法人主体',
    type: 'select',
    optionList: [],
    fieldNames: { label: 'name', value: 'name' },
    showSearch: true,
    rules: getRules('请选择法人主体'),
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
  },
  segmentId: {
    label: 'segment',
    slotName: 'segmentId',
  },
  link: {
    label: '链路',
    slotName: 'link',
  },
  riskType: {
    label: '审批类型',
    type: 'select',
    optionList: [
      { label: '一般审批', value: 1 },
      { label: '高风险审批', value: 2 },
    ],
    fieldNames: { label: 'label', value: 'value' },
    rules: getRules('请选择审批类型'),
  },
}

// ------------------申请明细View信息------------------
export const APPLY_VIEW_SCHEMA = {
  business: {
    label: '业务类型',
  },
  region: {
    label: '大区',
  },
  model: {
    label: '业务模式',
    slotName: 'model',
    rules: [{ required: true, message: '请选择注册时间' }], // 校验
  },
  creditArea: {
    label: '信控区',
  },
  link: {
    label: '链路',
    slotName: 'link',
  },
  segmentId: {
    label: 'segment',
    slotName: 'segmentId',
  },
  legalEntity: {
    label: '法人主体',
  },
  riskType: {
    label: '审批类型',
    filter: 'riskTypeFilter',
  },
}
